import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { Snackbar, Typography } from '@carto/meridian-ds/components'
import { NOTIFICATION_DURATION_IN_MS } from '@carto/meridian-ds/theme'
import { useAppDispatch, useAppSelector } from 'app/state'
import { AlertSeverity, hideNotification } from '../../state/notificationSlice'
import { useNotificationQueryParams } from './useNotificationParams'
import NotificationActions from './NotificationActions'

function AppNotification() {
  const dispatch = useAppDispatch()

  const {
    showNotification,
    notificationMessage,
    actions,
    notificationFormattedMessage,
    notificationType,
    formatValues,
    detailsMsg,
    error,
    timeout = NOTIFICATION_DURATION_IN_MS,
    closeable,
    autoWidth
  } = useAppSelector((state) => state.notifications)

  useNotificationQueryParams()

  const handleClose = () => dispatch(hideNotification())

  return (
    <Snackbar
      open={showNotification}
      autoHideDuration={timeout !== 0 ? timeout : null}
      severity={notificationType}
      onClose={handleClose}
      closeable={closeable}
      action={
        <>
          {actions?.map((action, index) => (
            <NotificationActions key={index} action={action} error={error} severity={notificationType} />
          ))}
          {!actions && error && <NotificationActions error={error} severity={AlertSeverity.Error} />}
        </>
      }
      autoWidth={autoWidth}
      sx={{ overflowWrap: 'anywhere' }}
    >
      <>
        {notificationFormattedMessage && notificationMessage ? (
          <FormattedMessage id={notificationMessage} values={formatValues} />
        ) : (
          notificationMessage
        )}

        {detailsMsg && (
          <Box mt={1}>
            <Typography variant="caption" component="p">
              {notificationFormattedMessage ? <FormattedMessage id={detailsMsg} /> : detailsMsg}
            </Typography>
          </Box>
        )}
      </>
    </Snackbar>
  )
}

export default AppNotification
